<div class="content">
  <div class="header">Scholarship Dashboard</div>
  <div class="count">{{ submissions.length }} Submissions</div>
  <div class="subheader">Submissions</div>
  <div class="submissions">
    <mat-expansion-panel *ngFor="let entry of submissions" class="submission">
      <mat-expansion-panel-header>
        <div class="label-panel">{{ entry.first }} {{ entry.last }}</div>
      </mat-expansion-panel-header>
      <div class="contacts">
        <div class="contact">
          <div class="label">Candidate</div>
          <div class="field">Name: {{ entry.first }} {{ entry.last }}</div>
          <div class="field">USATF ID: {{ entry.usatf }}</div>
          <div class="field">Email: {{ entry.email }}</div>
          <div class="field">
            Date of Birth: {{ entry.dob.toLocaleDateString() }}
          </div>
          <div class="field">Grade: {{ entry.grade }}</div>
          <div class="field">School: {{ entry.grade }}</div>
        </div>
        <div class="contact">
          <div class="label">Parent</div>
          <div class="field">
            Name: {{ entry.parent.first }} {{ entry.parent.last }}
          </div>
          <div class="field">Email: {{ entry.parent.email }}</div>
          <div class="field">Phone: {{ entry.parent.cell }}</div>
        </div>
      </div>
      <div class="label">Essays</div>
      <div class="field">
        Prompt: In 300 words or less, tell us about your goals and aspirations
        both on and off the track. In addition, tell us why you believe you
        deserve the NHF scholarship and anything we should take into
        consideration.
      </div>
      <div class="field">Response: {{ entry.essays.goalsAndAspirations }}</div>
      <br />
      <div class="field">
        Prompt: Tell us your favorite Natasha Hastings fact and one way Natasha
        has inspired you, whether its on or off the track!
      </div>
      <div class="field">Response: {{ entry.essays.favoriteNH }}</div>
      <div class="label">Recommendation Letters</div>
      <div class="field" *ngFor="let file of entry.reqs; index as i">
        Letter {{ i + 1 }}:
        <a class="fas fa-download" [href]="file" target="_blank"></a>
      </div>
    </mat-expansion-panel>
  </div>
</div>
